// extracted by css-extract-rspack-plugin
export default {"iconContainer":"_ZZID","commandItemStack":"XWFA0","commandButton":"gcskf"};